import { createTheme } from "@mui/material/styles";
import { styled, Theme, CSSObject } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';

const drawerWidth = 298;

const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  '&.MuiPaper-elevation0': {
    borderRight: '3px solid #fff',
  },
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

export const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);

export const filterTheme = createTheme({
  components: {
    MuiDrawer: {
      styleOverrides: {
        root: {
          width: drawerWidth,
          flexShrink: 0,

          '&.MuiDrawer-docked': {
            boxSizing: 'content-box',
          },

          '& .MuiDrawer-paper': {
            position: 'static',
            backgroundColor: '#fefeff',
            alignItems: 'center',
            border: 'none',

            '&::-webkit-scrollbar': {
              height: 3,
              width: 8,
            },

            '&::-webkit-scrollbar-thumb ': {
              background: '#D9D9D9',
              borderRadius: 21,

              '&:hover': {
                backgroundColor: '#888'
              }
            },
          },
        },
      },
    },
  },
});